// extracted by mini-css-extract-plugin
export default {"base":"styles-module--base--VOlLN","move":"styles-module--move--STS1X"};